<template>
  <div class="APeriodSelector">
    <el-select
      v-model="val"
      v-show="!hideSelect"
      class="period-selector"
      placeholder="기간"
      size="mini"
      :disabled="disabled"
      @change="handleChange"
    >
      <el-option
        v-for="item in getOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
    <el-form :model="period" :rules="rules" ref="form">
      <div v-if="isCustom" class="APeriodSelector">
        <el-form-item prop="startDate">
          <ADatePicker
            v-model="period.startDate"
            size="mini"
            placeholder="시작일"
            :disabled="disabled"
            @change="handleChangePeriod"
          />
        </el-form-item>
        <el-form-item prop="endDate">
          <ADatePicker
            v-model="period.endDate"
            size="mini"
            placeholder="종료일"
            :disabled="disabled"
            @change="handleChangePeriod"
          />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "APeriodSelector",
  data() {
    let validatePeriod = (rule, value, callback) => {
      if (this.period.startDate > this.period.endDate) {
        callback(new Error("앞의 날짜보다 늦습니다"));
      } else {
        callback();
      }
    };
    return {
      isCustom: false,
      valid: true,
      val: "",
      period: {
        startDate: "",
        endDate: ""
      },
      rules: {
        startDate: [
          { required: true, message: "시작일을 선택하세요.", trigger: "blur" }
        ],
        endDate: [
          { required: true, message: "종료일을 선택하세요.", trigger: "blur" },
          { validator: validatePeriod, trigger: "blur" }
        ]
      }
    };
  },
  props: {
    value: {
      type: [String, Object],
      default: "1m"
    },
    options: {
      type: Array,
      default: function() {
        return [
          { value: "0d", label: "오늘" },
          { value: "1w", label: "1주" },
          { value: "2w", label: "2주" },
          { value: "1m", label: "1개월" },
          { value: "2m", label: "2개월" },
          { value: "6m", label: "6개월" }
        ];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideSelect: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    value: function(val) {
      if (typeof val === 'object') {        
        this.isCustom = true;
        this.val = 'custom';
        this.changeValue(val.value);
      } else {
        this.val = val;
        this.changeValue(this.val);
      }
    }
  },
  created() {
    if (typeof this.value === 'object') {
      this.isCustom = true;
      this.val = 'custom';
      this.period = this.value;
      this.changeValue(this.value.value);
    } else {
      this.val = this.value;
      this.changeValue(this.val);
    }
  },
  computed: {
    getOptions: function() {
      let this_option;
      if (this.options[this.options.length - 1].value !== "custom") {
        this_option = this.options.concat([
          { value: "custom", label: "사용자 정의" }
        ]);
      } else {
        this_option = this.options;
      }
      return this_option;
    }
  },
  methods: {
    changeValue(val) {
      if (!val || val === "custom") {
        return;
      }
      let period = val.substring(0, val.length - 1);
      let unit = val.substring(val.length - 1, val.length);
      if (unit === "m") {
        unit = "M";
      } //change for moment.js
      if (period.substring(0, 1) === '-') {
        this.period = {
          startDate: this.util.getDate(),
          endDate: this.util.addPeriod(-period, unit)
        };
      } else {
        this.period = {
          startDate: this.util.addPeriod(-period, unit),
          endDate: this.util.getDate()
        };
        if (period > 0) {
          this.period.startDate = this.util.addDays(this.period.startDate, 1);
        }
      }
      this.valid = true;
      this.emitValue();
    },
    emitValue() {
      let result = {
        value: this.val,
        valid: this.valid,
        startDate: this.util.getDateString(this.period.startDate).toString(),
        endDate: this.util.getDateString(this.period.endDate).toString()
      };
      this.$emit("change", result);
    },
    handleChange(value) {
      this.isCustom = value === "custom";
      if (this.value) {
        this.$emit("input", value);
        this.changeValue(value);
      } else this.value = value;
    },
    handleChangePeriod() {
      this.$refs.form.validate(valid => {
        this.valid = valid;
        this.emitValue();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.APeriodSelector {
  > * {
    display: inline-block;
    margin-right: 10px;
  }
}
.period-selector {
  width: 140px;
}
</style>
